import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from '@/router/authenticated-route';
import CompanyCreateSuccessPage from '@/features/companies/company-create-success/CompanyCreateSuccessPage';

export const companyCreateSuccessRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/companies/create/success',
  component: CompanyCreateSuccessPage,
});
